import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { EcdStates } from '../../root/ecd-model';
import { getEcdEpiContent, setEpiContent, unloadEpiContent } from '../ducks/epi-api';
import { BasePageModel, PageType, EcdNotFoundPage } from '../models/ecd-page-models';
import { SiteSettingsProps } from '../models/epi-model';


export function useEpiPageContent(pathOverride?: string) {

    const language = useSelector<EcdStates, string>(state => state.globalization?.currentlanguage);
    const pageData = useSelector<EcdStates, BasePageModel>(state => state.epiProps?.pageData?.epiContent);
    const guid = useSelector<EcdStates, string>(state => state.authenticatedState?.clientGuid);
    const siteSettings = useSelector<EcdStates, SiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);
    const location = useLocation();

    const path = pathOverride || location?.pathname;

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(unloadEpiContent());
        dispatch(getEcdEpiContent(
            path,
            language,
            { guid },
            (data) => dispatch(setEpiContent(data)),
            () => dispatch(setEpiContent(
                {
					pageType: PageType.NotFoundPage,
                    pageTitle: siteSettings?.error404Title,
                    mainContent: siteSettings?.error404,
                } as EcdNotFoundPage))));
    }, [path]);

    return pageData;
}